export const API_ID = process.env.RAZZLE_ALGOLIA_API_APP_ID;

export const API_KEY = process.env.RAZZLE_ALGOLIA_API_SEARCH_KEY;

export const API_WRITE_KEY = process.env.RAZZLE_ALGOLIA_API_WRITE_KEY;

export const INDEX_NAME = process.env.RAZZLE_ALGOLIA_INDEX_NAME;
